import { ChromePicker } from 'react-color';
import colorPickerIcon from '../../img/icons/color-picker.svg';
import { CircularProgress, IconButton } from '@mui/material';
import useColorPicker from './hooks';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ColorPicker = ({onColorChange, onConfirmation, loading, disabled}) => {

    const { color, openColorPicker, handleColorChange, toggleColorPicker } = useColorPicker({onColorChange, onConfirmation});
    
    return (
        <>
        <IconButton onClick={toggleColorPicker} disabled={disabled}>
            {
                loading
                ? <CircularProgress size="20px" />
                :openColorPicker 
                    ? <CheckCircleIcon sx={{ color: "var(--orange)", fontSize: "20px" }}/>
                    : <img src={colorPickerIcon} alt="" />
            }
        </IconButton>
        {
          openColorPicker 
            ? 
              <div style={{ position: 'absolute', zIndex: 1000, right: "20%" }}>
                <ChromePicker color={color} onChange={handleColorChange} />
              </div>
            : null
        }
        </>
    );
}
 
export default ColorPicker;